export const action = (name, payload) => ({
    type: name,
    payload
});